import { TitleText } from '@/components/TitleText';
import { BodyText } from '@/components/BodyText';
import { Box, Button } from '@mui/material';
import { FilterAlt } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { ZeroStateContainer, ZeroStateContent } from './ZeroStateContainer';

export const ZeroStateFiltered = () => {
  const theme = useTheme();
  const apiReference = useGridApiContext();

  const handleClearFilters = () => {
    apiReference.current.setFilterModel({ items: [] });
  };

  return (
    <ZeroStateContainer>
      <ZeroStateContent>
        <Box sx={{ marginBottom: '16px' }}>
          <FilterAlt sx={{ fontSize: 64, color: theme.palette.text.secondary }} />
        </Box>
        <TitleText sx={{ marginBottom: '8px' }}>No results found</TitleText>
        <BodyText color='text.secondary' sx={{ marginBottom: '24px' }}>
          Your current filters didn&apos;t match any items in this folder. Try adjusting your filters or clear them to
          see all contents.
        </BodyText>
        <Button variant='outlined' onClick={handleClearFilters} sx={{ textTransform: 'none', marginTop: '16px' }}>
          Clear all filters
        </Button>
      </ZeroStateContent>
    </ZeroStateContainer>
  );
};
